/**
 * The platforms we publish a "MaJourneys vs ..." page for.
 *
 * Brand names are proper nouns and stay identical in every locale. `url` is
 * the brand's own home page, used only as the JSON-LD `sameAs` so search
 * engines tie the page to the right company.
 */
export const COMPARE_BRANDS = ["getyourguide", "viator"] as const;

export type CompareBrandSlug = (typeof COMPARE_BRANDS)[number];

export interface CompareBrand {
  slug: CompareBrandSlug;
  name: string;
  url: string;
}

export const COMPARE_BRAND_BY_SLUG: Record<CompareBrandSlug, CompareBrand> = {
  getyourguide: { slug: "getyourguide", name: "GetYourGuide", url: "https://www.getyourguide.com" },
  viator: { slug: "viator", name: "Viator", url: "https://www.viator.com" },
};

export function isCompareBrand(slug: string): slug is CompareBrandSlug {
  return (COMPARE_BRANDS as readonly string[]).includes(slug);
}
